/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component, OnInit, ViewChild, inject} from '@angular/core';
import {IxActiveModal, IxNumberInput, ToastService} from '@siemens/ix-angular';
import {PassportService} from '../../../../services/passport.service';
import {TranslateService} from '@ngx-translate/core';
import {AppSettings} from '../../../../models/Constants';

@Component({
  selector: 'app-modal-create-children',
  standalone: false,
  templateUrl: './modal-create-children.component.html',
  styleUrl: './modal-create-children.component.scss',
})
export class ModalCreateChildrenComponent implements OnInit {
  private readonly passportService = inject(PassportService);
  readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);
  readonly activeModal = inject(IxActiveModal);

  @ViewChild('numberOfChildrenToBeCreated')
  numberOfChildrensToBeCreated!: IxNumberInput;

  numberOfPassports = 1; // Initial value for number of passports
  minNumberOfPassports = 1;
  maxNumberOfPassports = AppSettings.MAX_NUMBER_OF_CHILD_PASSPORTS;

  masterPassportId?: string;
  isTemplateCreationInProgress = false;

  ngOnInit(): void {
    this.masterPassportId = this.activeModal.data.id;
    this.isTemplateCreationInProgress =
      this.activeModal.data.isTemplateCreationInProgress;
  }

  async onAddIndividualPassportClick() {
    if (this.isNumberOfPassportsValid()) {
      await this.passportService.createChildren(
        this.masterPassportId,
        this.numberOfPassports,
      );
      this.translateService
        .get('battery_pass.list.children_added')
        .subscribe((msg: string) => {
          this.toastService.show({message: msg, type: 'success'});
        });
      this.activeModal.close('finish');
    }
  }

  onNumberOfPassportsChange(): void {
    this.numberOfPassports =
      this.numberOfChildrensToBeCreated.value ?? this.minNumberOfPassports;
  }

  isNumberOfPassportsValid(): boolean {
    const MAX_CHILDREN_PASSPORTS = 100;
    return (
      this.numberOfPassports >= 1 &&
      this.numberOfPassports <= MAX_CHILDREN_PASSPORTS
    );
  }
}
